
export function getLocation() {
  return window && window.location || {
    host: null
  };
}